export default __webpack_public_path__ + "static/media/taggedImg3.92c13a10.jpeg";